import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OnboardingPreferencesList,
  OnboardingPreferencesOption,
} from '@/pages/Onboarding/components/PreferencesList';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { useQueryOnboardingCategories } from '@/pages/Onboarding/hooks/useQueryOnboardingCategories';
import { OnboardingParamsTool } from '@/pages/Onboarding/utils/paramsTool';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { LayoutDataType } from '../../types';

import { PreferencesStyles } from './Preferences.styles';

export const ScreenPreferences: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Twin Preferences',
      });
    }

    preloadImage(
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/svg-sprite.svg',
    );
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const categories = form.watch('categories');
  const preloadCategories = form.getValues('preloadCategories');

  const handleNextStep = () => {
    userService.createOrUpdate({
      categories,
      onboarding_data: {
        first_categories: categories,
      },
    });

    OnboardingParamsTool.setParam('step', 'topics');

    wizard.nextStep();
  };

  useQueryOnboardingCategories({
    enabled: preloadCategories.length === 0,
    form,
  });

  return (
    <PreferencesStyles>
      <OnboardingNavigation />
      <OnboardingTitle>Who’s your preferred AI-partner?</OnboardingTitle>
      <OnboardingSubtitle>
        You can change it later in the app
      </OnboardingSubtitle>

      <IonContent>
        <OnboardingPreferencesList>
          {preloadCategories &&
            preloadCategories.map((option) => {
              const active = categories?.includes(option.id);

              return (
                <OnboardingPreferencesOption
                  form={form}
                  active={active}
                  option={option}
                  key={option.id}
                />
              );
            })}
        </OnboardingPreferencesList>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        disabled={categories.length === 0}
      />
    </PreferencesStyles>
  );
};
